import React from "react"
import {
  Navigate,
  type RouteObject,
  useLocation,
  useParams
} from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import LeadAddPage from "../../../Lead/LeadAddPage"
import LeadFinancialPage from "../../../Lead/LeadFinancialPage"
import LeadWorkspacePage from "../../../Lead/LeadWorkspacePage"
import LeadsPage from "../../../Leads/LeadsActivePage/LeadsActivePage"

function LeadEditRedirect() {
  const { id = "" } = useParams()
  const { search } = useLocation()

  return (
    <Navigate
      replace
      to={{ pathname: RoutesPaths.lead.view(id), search }}
    />
  )
}

export const leadRoutes: RouteObject[] = [
  {
    path: RoutesPaths.lead.list,
    element: (
      <PermissionGate
        description={"You don't have permission to view leads."}
        paths={["leads.leads.lead_view"]}
      >
        <LeadsPage />
      </PermissionGate>
    ),
    // A child route keeps this LeadsPage instance mounted while the wizard is
    // open; a sibling route would remount and refetch the list behind it.
    children: [
      {
        path: RoutesPaths.lead.add,
        element: (
          <PermissionGate
            description={"You don't have permission to create leads."}
            paths={["leads.leads.lead_create"]}
          >
            <LeadAddPage />
          </PermissionGate>
        )
      }
    ]
  },
  {
    // The archived leads list lives in the unified Archive now. Redirecting
    // rather than mounting the page a second time is what keeps the sidebar
    // honest: on `/leads/inactive` it highlighted **Leads**, because the
    // highlight matches on the `leads/` prefix, so the user's nav position
    // disagreed with what they were reading.
    path: RoutesPaths.lead.listInactive,
    element: <Navigate replace to={RoutesPaths.archive.leads} />
  },
  {
    path: RoutesPaths.lead.listArchivedLegacy,
    element: <Navigate replace to={RoutesPaths.archive.leads} />
  },
  {
    path: RoutesPaths.lead.view(":id"),
    element: (
      <PermissionGate
        description={"You don't have permission to view lead."}
        paths={["leads.leads.lead_view"]}
      >
        <LeadWorkspacePage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.lead.financial(":id"),
    element: (
      <PermissionGate
        description={"You don't have permission to edit lead."}
        paths={["leads.leads.lead_edit"]}
      >
        <LeadFinancialPage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.lead.legacyEdit(":id"),
    element: <LeadEditRedirect />
  }
]
